const sandbox = {
  env: 'sandbox',
  axios: {
    base: ' https://bb71ac93.ngrok.io/api',
  },
  pagseguro: {
    production: 'https://stc.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.lightbox.js',
    sandbox: 'https://stc.sandbox.pagseguro.uol.com.br/pagseguro/api/v2/checkout/pagseguro.lightbox.js',
  },
  paypal: {
    url: 'https://www.paypalobjects.com/api/checkout.js',
  },
};

const prod = {
  env: 'production',
  axios: {
    base: 'https://api.rdsms.com.br/api/',
  },
};

export default Object.assign({}, sandbox, process.env.NODE_ENV === 'production' ? prod : {});



// WEBPACK FOOTER //
// ./src/core/config.js